/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from 'react-router-dom';
import { mUtils } from '../helper/utils';

export interface MPageHeaderProps {
  crumbs: string[];
}

function MPageHeader(props: MPageHeaderProps) {
  const navigate = useNavigate();
  return (
    <div className="page-header page-header-light">
      <div className="page-header-content header-elements-md-inline">
        <div className="page-title d-flex">
          <h4>
            <i
              className="icon-arrow-left52 mr-2"
              onClick={() => navigate(-1)}
            ></i>
            {mUtils.getBreadCrumbs(props.crumbs)}
          </h4>
          <a href="#" className="header-elements-toggle text-default d-md-none">
            <i className="icon-more"></i>
          </a>
        </div>
      </div>

      <div className="breadcrumb-line breadcrumb-line-light header-elements-md-inline">
        <div className="d-flex">
          <div className="breadcrumb">
            <span className="breadcrumb-item active">
              {mUtils.getBreadCrumbs(props.crumbs, ' / ')}
            </span>
          </div>

          <a href="#" className="header-elements-toggle text-default d-md-none">
            <i className="icon-more"></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default MPageHeader;
